module.exports = __webpack_public_path__ + "static/group5_2-15bfd4ef38007d2ba070b83b389339f5.webp";